import { X } from 'lucide-react';

export default function TierModal({ onCancel, tier, benefits, isOpen }) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-orange-100 px-6 pt-6 pb-3 rounded-lg shadow-lg max-w-sm w-full">
        <p className="text-lg font-semibold text-orange-500 mb-2">สิทธิประโยชน์ระดับ {tier.customer_tier_type_name}</p>
        <div className="h-1 bg-orange-500 rounded mb-2"></div>
        <div className="my-3">
          {benefits && benefits.map((item, idx) => (
            <div className="text-orange-500">{idx+1}. {item.customer_tier_benefit_name}</div>
          ))}
        </div>
        <div className="flex justify-center pt-5">
          <button className={`w-10 h-10 rounded-full flex items-center justify-center bg-amber-600 hover:scale-95`} onClick={onCancel}>
            <X className="w-5 h-5 text-orange-200"/>
          </button>
        </div>
      </div>
    </div>
  );
};